import {addDays, addMonths} from "date-fns"
import z from "zod"

import {AssertUnreachable} from "../assertUnreachable"

export const frequencySchema = z.enum(["Weekly", "Fortnightly", "Monthly"])
export const FREQUENCIES = frequencySchema.options

export type Frequency = z.infer<typeof frequencySchema>

export function getIncrementFn(frequency: Frequency): (date: Date) => Date {
	switch (frequency) {
		case "Weekly":
			return (date) => addDays(date, 7)
		case "Fortnightly":
			return (date) => addDays(date, 14)
		case "Monthly":
			return (date) => addDays(addMonths(date, 1), -1)
		default:
			AssertUnreachable(frequency, `Unsupported frequency: ${frequency}`)
	}
}

export function getMaxDate(frequency: Frequency): Date {
	return getIncrementFn(frequency)(new Date())
}
